import { useCallback, useReducer } from 'react';
import { Helmet } from 'react-helmet';

import { HeaderSeparator } from '@/components/reports/header';

import { ReportBody } from '../reports/body';

import { PivotDataProvider, usePivotData } from './Context';
import Header from './Header';
import PermanentLink from './PermanentLink';
import Sidebar from './Sidebar';
import Table from './Table';

function Pivot({ data, configure, reportView, isLoading, useLoad, title }) {
  const { onChagePivotData } = usePivotData()
  const reducer = useCallback((state, update) => ({ ...state, ...update }), [])
  const [params, dispatchOnApply] = useReducer(reducer, INITIAL_STATE)
  useLoad(params)

  const handleChange = useCallback(state => {
    const { filterby, pivotby, aggregator, groupby, metrics, sortby, sort } = state
    const { cols, rows, metric, formatter, showHeatmap, heatmapColor } = pivotby
    onChagePivotData({ cols, rows, metric, formatter, showHeatmap, heatmapColor, sort, aggregator })
    dispatchOnApply({ filterby, groupby, aggregator, metrics, sortby })
  }, [onChagePivotData])

  return <>
    <Helmet title={title} />
    <Header value={params} isLoading={isLoading} onApply={dispatchOnApply} title={title}>
      <HeaderSeparator />
      <PermanentLink value={params} onChange={handleChange} />
      <Sidebar value={params} configure={configure} reportView={reportView} onApply={handleChange} />
    </Header>
    <ReportBody contentClassName='p-4'>
      <Table data={data} />
    </ReportBody>
  </>
}

export default function Layout(props) {
  return <PivotDataProvider>
    <Pivot {...props} />
  </PivotDataProvider>
}

const INITIAL_STATE = {
  startDate: null,
  endDate: null,
  filterby: {},
}
